import OtpInput from "react-otp-input";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { parseNumberFromAnotherLocale } from "../utils";

function OTP({
  question,
  onSubmitHandler,
  toVerify,
  patientId,
  verifyCall,
  resendOTPCall,
  goBackHandler,
  ctaText,
  isResendingOTP = false,
}) {
  const [otp, setOtp] = useState({ otp: "" });
  const [isVerifyingOTP, setOTPVerification] = useState(false);
  const [isVerificationFailed, setVerificationFailure] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { t } = useTranslation();

  // TODO: Code duplicated in check-sms as well, make it better
  const durationInSeconds = 45;
  let resendTimer = undefined;
  const [isResendOTPBlocked, setIsResentOTPBlocked] = useState(true);
  let [resendCounter, setResendCounter] = useState(durationInSeconds);
  const [waitText, setWaitText] = useState("");

  useEffect(() => {
    // Init
    resendTimer = setInterval(resendOTPBlocker, 1000);
  }, []);

  const resendOTP = () => {
    if (isResendOTPBlocked) return;
    setOTPVerification(false);
    setVerificationFailure(false);
    setOtp({ otp: "" });
    resendOTPCall(toVerify);
    resendTimer = setInterval(resendOTPBlocker, 1000);
  };

  const resendOTPBlocker = () => {
    setIsResentOTPBlocked(true);
    const _timeUnit = resendCounter === 1 ? "second" : "seconds";
    setWaitText(`Resend OTP in ${resendCounter} ${_timeUnit}`);
    setResendCounter(resendCounter--);
    if (resendCounter === 0) {
      setIsResentOTPBlocked(false);
      setResendCounter(durationInSeconds);
      setWaitText("");
      if (resendTimer !== undefined) clearInterval(resendTimer);
    }
  };
  const handleChange = (otp) => {
    // init state
    setOtp({ otp });
    setOTPVerification(false);
    setVerificationFailure(false);

    // Make call if all digits entered
    if (otp.length === 6 && verifyCall !== null) {
      try {
        const otpValue = parseNumberFromAnotherLocale(otp);
        console.log("verifying OTP");
        setOTPVerification(true);
        verifyCall({ otp: otpValue }).then((responseData) => {
          setOTPVerification(false);
          if (responseData["status"]["success"] !== true) {
            setVerificationFailure(true);
            setErrorMessage(responseData["status"]["message"]);
          } else {
            setVerificationFailure(false);
            onSubmitHandler({ otp: otp });
          }
        });
      } catch (e) {
        setVerificationFailure(true);
        setErrorMessage("Unable to parse input");
      }
    }
  };

  return (
    <>
      <div className="body_content">
        <div className="inner_body ">
          <h3 className="headtitle mb-2">{question}</h3>
          <h4 className="subtitle mb-2">
            {t("onboard.VERIFY_MOBILE.description")}
          </h4>
          <h4 className="subtitle">
            <span className="txt_color_gray">
              ({t("sidenav.MOBILE.sentotp")}{" "}
            </span>
            <span>{toVerify}</span>
            <span className="txt_color_gray">)</span>
            <Link
              to="#"
              onClick={() => goBackHandler()}
              className="link_resend_otp ml-2"
            >
              <span>{t("appointment.BUTTON.change")}</span>
            </Link>
          </h4>
          <div className="otp_block d-flex align-items-center">
            <OtpInput
              value={otp.otp}
              onChange={handleChange}
              numInputs={6}
              isInputNum={true}
              inputStyle={{
                width: "2.3rem",
                height: "2.4rem",
                margin: "8px 0.3rem",
                fontSize: "1rem",
                borderRadius: 4,
                border: "2px solid rgba(0,0,0,0.3)",
              }}
            />
            {isVerifyingOTP ? (
              <span
                style={{ marginLeft: "1em" }}
                className="icon ml-4 fa-solid fa-spinner fa-spin"
              ></span>
            ) : (
              <></>
            )}
            {isVerificationFailed ? (
              <span
                style={{ marginLeft: "1em", color: "red" }}
                className="icon ml-4 fa-solid fa-xmark"
              ></span>
            ) : (
              <></>
            )}
            {/*otp.otp && (
              <span className="icon ml-4">
                <GreenTick className="img-fluid" />
              </span>
            )*/}
          </div>
          {/*
           * TODO:
           * Unable to delete OTP from mobile, hence added this link of "Clear OTP"
           * Add translations if functionality is apporved
           */}

          <div className=" d-flex justify-content-between mt-2">
            <Link
              to="#"
              onClick={() => {
                setOTPVerification(false);
                setVerificationFailure(false);
                setOtp({ otp: "" });
              }}
              className="link_resend_otp "
            >
              {t("sidenav.MOBILE.clearotp")}
            </Link>
            <Link
              to="#"
              onClick={() => resendOTP()}
              className={
                isResendOTPBlocked
                  ? "link_resend_otp ml-5 disabled-txt "
                  : "link_resend_otp ml-5"
              }
            >
              {isResendingOTP && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              &nbsp;{t("onboard.VERIFY_MOBILE.resendCTA")}
            </Link>
          </div>
          <div>
            <br />
            {errorMessage !== "" && isVerificationFailed && (
              <span className="txt_help " style={{ color: "red" }}>
                {errorMessage}
              </span>
            )}
          </div>
          <div className="d-flex justify-content-center">
            <br />
            {isResendOTPBlocked && (
              <span className="txt_help txt_color_orange_2">{waitText}</span>
            )}
          </div>
          <div className="btn_block bottom_button d-flex justify-content-center">
            <button
              disabled={otp["otp"].length < 6 || isVerifyingOTP}
              className="btn btn_primary"
              onClick={() => handleChange(otp.otp)}
            >
              {ctaText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default OTP;
